import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Breadcrumb } from "react-bootstrap";
import { SuperSEO } from "react-super-seo";
import PsContext from "../../context";
import { DB_POSTFIX, upperCase } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";

import LoaderIcon from "../../utils/LoaderIcon";
import Announcements from "../homePage/announcements";
import NotFound from "../notFound";

const CustomPage = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState({});

  useEffect(() => {
    loadData();
  }, [props.match.params]);

  const loadData = () => {
    setLoader(true);
    axios
      .post(
        ServiceUrl.GET_PAGE +
          "?sadb=" +
          DB_POSTFIX +
          "&slug=" +
          props.match.params.slug
      )
      .then((res) => {
        if (res.data.status === "1") {
          setDataList(res.data.data);
        }
        setLoader(false);
      });
  };

  const field = (fieldName) => dataList[fieldName] || "";

  return (
    <div style={{ minHeight: "350px" }}>
      {loader && <LoaderIcon />}

      {!loader && dataList.id && (
        <>
          {dataList && dataList.id && (
            <SuperSEO
              title={context.settingValue("web_site_name")}
              description={
                context.settingValue("web_site_meta_description") ||
                "Aditanar College"
              }
              keywords={
                context.settingValue("web_site_meta_keyword") ||
                "Aditanar College"
              }
              lang="en"
              openGraph={{
                ogTitle:
                  context.settingValue("web_site_name") ||
                  " Dr.Sivanthi Aditanar College",
                ogDescription:
                  context.settingValue("web_site_meta_description") ||
                  "Dr.Sivanthi Aditanar College",
              }}
            />
          )}
          <section
            className="page-hero d-flex align-items-center"
            style={{
              backgroundImage:
                "url('https://portal.aei.edu.in//files_list/aei/drsacoe/fm/website/bredcrumbs/Campus_View2lwdf.jpg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              minHeight: "220px",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0,0,0,0.5)",
              }}
            ></div>

            <div className="container position-relative text-white">
              <Breadcrumb>
                <Breadcrumb.Item href="/" className="text-light">
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item active className="text-light">
                  {context.isRegionalLanguage()
                    ? field("title_unicode") || upperCase(field("title"))
                    : upperCase(field("title"))}
                </Breadcrumb.Item>
              </Breadcrumb>
              <h2 className="fw-bold mb-0">
                {context.isRegionalLanguage()
                  ? field("title_unicode") || upperCase(field("title"))
                  : upperCase(field("title"))}
              </h2>
            </div>
          </section>

          <section className="pb-4">
            <div className="container ps_min_height px-3 py-4">
              <Row>
                <Col md={12}>
                  <div
                    className="page-content"
                    dangerouslySetInnerHTML={{
                      __html: context.isRegionalLanguage()
                        ? field("content_html_unicode") || field("content_html")
                        : field("content_html"),
                    }}
                  />
                </Col>
              </Row>
            </div>
          </section>
        </>
      )}

      {!loader && !dataList.id && <NotFound />}
    </div>
  );
};

export default CustomPage;
